import qs from 'qs';
import fetcher from '../../modules/ajio-fetch';
import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  getErrorStatusCode,
  errorParser,
  tokenReCreateParser,
  getFetcherHeader
} from '../../modules/ajio-fetch/utils';
import properties from '../../modules/ajio-util/properties';
import { setErrorObject } from '../../actions/shared/HTTPError';
import { createAnonymousLoginAtNode } from '../../actions/authUser';
import { getReferralConfigApi, isReferralCachedData } from './referAndEarnAPI';

const url = properties.getProperty('apiUrl');
const rilwebserviceUrl = '/rilfnlwebservices/v2/rilfnl';

function setReferralPageInfo(referralPageDetails = {}) {
  return {
    type: 'SET_REFERRAL_PAGE_DETAILS',
    referralPageDetails
  };
}

function setReferralPageFaqs(faqs = []) {
  return {
    type: 'SET_REFERRAL_PAGE_FAQS',
    faqs
  };
}

function setReferralEarningsDetails(earningsDetails = {}) {
  return {
    type: 'SET_REFERRAL_EARNINGS_DETAILS',
    earningsDetails
  };
}

function setReferralTotalEarning(totalEarning = {}) {
  return {
    type: 'SET_REFERRAL_TOTAL_EARNINGS',
    totalEarning
  };
}

export function setRefereeIncentive(incentive = 0, refereeIncentiveExpiresIn = {}) {
  return {
    type: 'SET_REFEREE_INCENTIVE',
    refereeIncentive: incentive,
    refereeIncentiveExpiresIn
  };
}

function setAnonymousReferrerIncentive(incentive = 0) {
  return {
    type: 'SET_ANONYMOUS_REFERRER_INCENTIVE',
    anonymousReferrerIncentive: incentive
  };
}

export function setReferrerDetails(referrerDetails = {}) {
  return {
    type: 'SET_REFERRER_DETAILS',
    referrerDetails
  };
}

export function unsetReferrerDetails(referrerDetails = {}) {
  return {
    type: 'UNSET_REFERRER_DETAILS',
    referrerDetails
  };
}

function setReferrerEarningsFetchingStatus(referralEarningFetchStatus = '') {
  return {
    type: 'SET_REFERRER_EARNINGS_FETCH_STATUS',
    referralEarningFetchStatus
  };
}

export function setReferrerStateToEmpty() {
  return {
    type: 'SET_REFERRAL_DEFAULT_STATE',
  };
}

export function getReferralPageInfo(requestObj = {}) {
  const { request = {} } = requestObj;
  const headerInfo = getFetcherHeader(request);
  return dispatch => {
    const apiEndPoint = `${url}${rilwebserviceUrl}/newdesignhomepage?pageId=referral`;
    const { A: token = '' } = request.cookies;
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'content-type': 'application/json',
          ...headerInfo
        }
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(setReferralPageInfo(response));
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          dispatch(setErrorObject(errorObj));
        });
      });
  };
}

export function getReferralPageFaqs(requestObj = {}) {
  const { request = {} } = requestObj;
  const headerInfo = getFetcherHeader(request);
  return dispatch => {
    const apiEndPoint = `${url}${rilwebserviceUrl}/referral/questions?pageLabel=referral`;
    const { A: token = '' } = request.cookies;
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'content-type': 'application/json',
          ...headerInfo
        }
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(setReferralPageFaqs(response));
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          dispatch(setErrorObject(errorObj));
        });
      });
  };
}

export function getReferralTotalEarnings(requestObj = {}) {
  const { request = {} } = requestObj;
  const headerInfo = getFetcherHeader(request);
  return dispatch => {
    const { A: token = '', U: userId = '' } = request.cookies;
    const apiEndPoint = `${url}${rilwebserviceUrl}/referral/referralWalletbalance?${qs.stringify({
      userId
    })}`;
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'content-type': 'application/json',
          ...headerInfo
        }
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(setReferralTotalEarning(response));
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          dispatch(setErrorObject(errorObj));
        });
      });
  };
}

export function getReferralEarningsDetails(requestObj = {}, isRecursivelyCalling = false) {
  const { request = {} } = requestObj;
  const { cookies } = request;
  const headerInfo = getFetcherHeader(request);
  return dispatch => {
    const { A: token = '' } = cookies;
    getReferralConfigApi(token, headerInfo)
      .then(response => {
        dispatch(setReferralEarningsDetails(response));
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          if (statusCode === 401 && !isRecursivelyCalling) {
            return tokenReCreateParser(statusCode, errorObj)
              .then(() => {
                return getReferralEarningsDetails(requestObj, true)(dispatch);
              })
              .catch(() => {
                dispatch(setErrorObject(errorObj));
              });
          }
          dispatch(setErrorObject(errorObj));
        });
      });
  };
}

export function getReferralIncentives(requestObj = {}, isRecursivelyCalling = false) {
  const { request = {} } = requestObj;
  const { cookies } = request;
  const headerInfo = getFetcherHeader(request);
  return async dispatch => {
    try {
      const { A: token = '' } = cookies;
      const responseData = await getReferralConfigApi(token, headerInfo);
      dispatch(setReferralEarningsDetails(responseData));
    } catch (error) {
      const statusCode = getErrorStatusCode(error);
      dispatch(setErrorObject(error));
      const errorObj = await errorParser(error, statusCode);
      if (statusCode === 401 && !isRecursivelyCalling) {
        return tokenReCreateParser(statusCode, errorObj)
          .then(() => {
            return getReferralIncentives(requestObj, true)(dispatch);
          })
          .catch(() => {
            dispatch(setErrorObject(errorObj));
          });
      }
      dispatch(setErrorObject(errorObj));
    } finally {
      return 'done';
    }
  };
}

export function getAnnonymousReferralEarningsDetails() {
  return async dispatch => {
    try {
      let responseData;
      if (isReferralCachedData()) {
        responseData = isReferralCachedData();
      } else {
        const anonymousToken = await createAnonymousLoginAtNode();
        const { access_token: token } = anonymousToken;
        responseData = await getReferralConfigApi(token);
      }
      const {
        referee: {
          refereeUserRegistration: { amount: signUpIncentive = 0, expiresIn = {} } = {}
        } = {}
      } = responseData;

      dispatch(setRefereeIncentive(signUpIncentive, expiresIn));
    } catch (error) {
      const statusCode = getErrorStatusCode(error);
      dispatch(setErrorObject(error));
      const errorObj = await errorParser(error, statusCode);
      dispatch(setErrorObject(errorObj));
    } finally {
      return 'done';
    }
  };
}

export function getReferrerIncentiveDespiteAuth(requestObj = {}, isRecursivelyCalling = false) {
  const { request = {} } = requestObj;
  const { cookies } = request;
  const headerInfo = getFetcherHeader(request);
  return async dispatch => {
    try {
      let responseData;
      if (isReferralCachedData()) {
        responseData = isReferralCachedData();
      } else {
        let token;
        token = cookies?.A;
        if (!token) {
          const anonymousToken = await createAnonymousLoginAtNode();
          token = anonymousToken?.access_token;
        }
        responseData = await getReferralConfigApi(token, headerInfo);
      }
      const { referrer: { totalBonus = 0 } = {} } = responseData;
      dispatch(setReferralEarningsDetails(responseData));
      dispatch(setAnonymousReferrerIncentive(totalBonus));
    } catch (error) {
      const statusCode = getErrorStatusCode(error);
      const errorObj = await errorParser(error, statusCode);
      if (statusCode === 401 && !isRecursivelyCalling) {
        return tokenReCreateParser(statusCode, errorObj)
          .then(() => {
            return getReferrerIncentiveDespiteAuth(requestObj, true)(dispatch);
          })
          .catch(() => {
            dispatch(setErrorObject(errorObj));
          });
      }
      dispatch(setErrorObject(errorObj));
    } finally {
      return 'done';
    }
  };
}

export function fetchReferrerEarnings() {
  return async dispatch => {
    dispatch(setReferrerEarningsFetchingStatus('FETCHING'));
    const apiEndPoint = '/api/referral/earnings-breakdown';

    try {
      const rawResponse = await fetcher(
        apiEndPoint,
        fetchGetJSONReqOpts({
          method: 'POST',
          headers: { 'content-type': 'application/json' }
        })
      );
      const response = await fetchGetJSONResHandler(rawResponse);
      dispatch(setReferralEarningsDetails(response));
      dispatch(setReferrerEarningsFetchingStatus('SUCCESS'));
    } catch (error) {
      dispatch(setReferrerEarningsFetchingStatus('FAILED'));
    }
  };
}
